import { IApplicationState } from '../../types/redux';

// TODO: В случае выигрыша эксперимента удалить в CD-243910.
export function selectBrokerConsultantBannerUrl(state: IApplicationState) {
  return state.config.brokerConsultantBannerUrl;
}
